import { render } from "./FotoView.vue?vue&type=template&id=070003fe&scoped=true"
import script from "./FotoView.vue?vue&type=script&lang=js"
export * from "./FotoView.vue?vue&type=script&lang=js"

import "./FotoView.vue?vue&type=style&index=0&id=070003fe&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-070003fe"]])

export default __exports__